import "./App.css";
import { useEffect, useState } from "react";
import Home from "../src/components/home/home";
import Step1 from "../src/components/step-1/step-1";
import Step2 from "../src/components/step-2/step-2";
import Step3 from "../src/components/step-3/step-3";
import Step4 from "../src/components/step-4/step-4";
import Step5 from "../src/components/step-5/step-5";
import Step6 from "../src/components/step-6/step-6";
import Step7 from "../src/components/step-7/step-7";
import Header from "./components/header/header";
import Footer from "./components/footer/footer";
import Loader from "./components/loader/loader";

import APIS from "../src/services/apis";
import { inicializarTagManager } from "./services/googleTagManager";
import TagManager from "react-gtm-module-nonce-aware";
import { Buffer } from "buffer";

function App() {
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [loadingFinal, setLoadingFinal] = useState(true);
  const [loading_carreras, setLoadingCarreras] = useState(false);
  const [backButton, setShowBackButton] = useState(false);
  const [tipoDoc, setTipoDoc] = useState(1);
  const [numDoc, setNumDoc] = useState("");
  const [email, setEmail] = useState("");
  const [captcha, setCaptcha] = useState("");
  const [nombre, setNombre] = useState("");
  const [apellido, setApellido] = useState("");
  const [situacion_laboral, setSituacionLaboral] = useState("");
  const [financiacion, setFinanciacion] = useState("");
  const [nivel_estudios, setNivelEstudios] = useState("");
  const [telefono, setTelefono] = useState("");
  const [region, setRegion] = useState("");
  const [termycond, setTyc] = useState(false);
  const [carrera, setCarrera] = useState("");
  const [sede, setSede] = useState("");
  const [regiones, setRegiones] = useState([]);
  const [carreras, setCarreras] = useState([]);
  const [modalidades, setModalidades] = useState([]);
  const [estudiante, setEstudiante] = useState("");
  const [simulacion, setSimulacion] = useState("");
  const [carrera_modalidad_sede, setCarreraModalidadSede] = useState("");
  const [certificado, setCertificado] = useState("");
  const [caracteristica_1, setCaracteristica_1] = useState("");
  const [caracteristica_2, setCaracteristica_2] = useState("");
  const [caracteristica_3, setCaracteristica_3] = useState("");
  const [downseling, setDownseling] = useState([]);

  const [loader, setLoader] = useState(true);

  const [situaciones_laboral, setSituacionesLaboral] = useState("");
  const [tipos_documentos, setTiposDocumentos] = useState("");
  const [niveles_estudio, setNivelesEstudio] = useState("");
  const [financiamientos, setFinanciamientos] = useState("");
  const [permitir_envio, setPermitirEnvio] = useState(false);

  const [valor_matricula_anual, setValorMatriculaAnual] = useState("");
  const [valor_arancel_anual, setValorArancelAnual] = useState("");
  const [valor_beca_matricula_unab, setValorMatriculaUnab] = useState("");
  const [valor_beca_arancel_unab, setValorArancelUnab] = useState("");
  const [valor_matricula_anual_unab, setValorMatriculaAnualUnab] =
    useState("0");
  const [valor_anual_con_becas, setValorAnualConBecas] = useState("");
  const [valor_mensual_con_becas, setValorMensualConBecas] = useState("");
  const [valor_nombre_carrera, setValorNombreCarrera] = useState("");
  const [valor_sede, setValorSede] = useState("");

  const [tipoDocAlert, setTipoDocAlert] = useState("required");
  const [numDocAlert, setNumDocAlert] = useState("required empty");
  const [emailAlert, setEmailAlert] = useState("required empty");
  const [captchaAlert, setCaptchaAlert] = useState("required empty");
  const [nombreAlert, setNombreAlert] = useState("required empty");
  const [apellidoAlert, setApellidoAlert] = useState("required empty");
  const [telefonoAlert, setTelefonoAlert] = useState("required empty");
  const [regionAlert, setRegionAlert] = useState("required");
  const [situacion_laboralAlert, setSituacionLaboralAlert] =
    useState("required empty");
  const [financiacionAlert, setFinanciacionAlert] = useState("required empty");
  const [nivel_estudiosAlert, setNivelEstudiosAlert] =
    useState("required empty");

  const [opening, setOpening] = useState(true);
  const [openingMsg, setOpeningMsg] = useState("");
  const [nueva_simulacion, setNuevaSimulacion] = useState(true);

  // CARGA PAGINA
  const startSimulacionPage0 = () => {
    inicializarTagManager();
    TagManager.dataLayer({
      dataLayer: {
        event: "checkout",
        pageType: "simulador-advance",
        ecommerce: {
          checkout: {
            actionField: {
              step: 1,
            },
          },
        },
      },
    });
  };

  // START FLUJO
  const startSimulacionPage1 = () => {
    TagManager.dataLayer({
      dataLayer: {
        event: "checkout",
        pageType: "simulador-advance",
        ecommerce: {
          checkout: {
            actionField: {
              step: 2,
            },
          },
        },
      },
    });
    setPage(1);
  };

  // BEFORE STEP START
  const tagManagerStepper = (actualPage) => {
    const rutCompleto = numDoc
      .replaceAll(".", "")
      .replaceAll("-", "")
      .toLowerCase();
    const buffer = Buffer.from(rutCompleto);
    const encodedRut = buffer.toString("base64");
    const docActual = tipos_documentos.find(
      ({ id_tipo_documento }) => id_tipo_documento === parseInt(tipoDoc)
    );
    let sitLabActual;
    let nivEstActual;
    let financiamientoActual;
    if (actualPage > 2) {
      sitLabActual = situaciones_laboral.find(
        ({ id_situacion_laboral }) =>
          id_situacion_laboral === parseInt(situacion_laboral)
      );
      nivEstActual = niveles_estudio.find(
        ({ id_nivel_estudios }) =>
          id_nivel_estudios === parseInt(nivel_estudios)
      );
      financiamientoActual = financiamientos.find(
        ({ id_financiamiento_carrera }) =>
          id_financiamiento_carrera === parseInt(financiacion)
      );
    }
    let modalidadActual;
    if (actualPage > 3)
      modalidadActual = carreras.filter(({ carreras }) =>
        carreras.find(({ id_carrera }) => id_carrera === carrera.id_carrera)
      );
    switch (actualPage) {
      case 1:
        TagManager.dataLayer({
          dataLayer: {
            event: "update",
            userid: encodedRut,
            tipo_documento: docActual.tipo_documento,
          },
        });
        TagManager.dataLayer({
          dataLayer: {
            event: "checkout",
            event_category: "simulador-advance",
            event_label: "Ingresar datos",
            userid: encodedRut,
            tipo_documento: docActual.tipo_documento,
            ecommerce: {
              checkout: {
                actionField: {
                  step: 3,
                },
              },
            },
          },
        });
        break;
      case 2:
        TagManager.dataLayer({
          dataLayer: {
            event: "checkout",
            event_category: "simulador-advance",
            event_label: "Datos personales",
            userid: encodedRut,
            tipo_documento: docActual.tipo_documento,
            ecommerce: {
              checkout: {
                actionField: {
                  step: 4,
                },
              },
            },
          },
        });
        break;
      case 3:
        TagManager.dataLayer({
          dataLayer: {
            event: "checkout",
            event_category: "simulador-advance",
            event_label: "Selecciona carrera",
            userid: encodedRut,
            tipo_documento: docActual.tipo_documento,
            nivel_estudios: sitLabActual.situacion_laboral,
            situacion_laboral: nivEstActual.nivel_estudios,
            como_financia: financiamientoActual.financiamiento_carrera,
            ecommerce: {
              checkout: {
                actionField: {
                  step: 5,
                },
              },
            },
          },
        });
        break;
      case 4:
        TagManager.dataLayer({
          dataLayer: {
            event: "checkout",
            event_category: "simulador-advance",
            event_label: "Selecciona sede",
            userid: encodedRut,
            tipo_documento: docActual.tipo_documento,
            nivel_estudios: sitLabActual.situacion_laboral,
            situacion_laboral: nivEstActual.nivel_estudios,
            como_financia: financiamientoActual.financiamiento_carrera,
            modalidad: modalidadActual[0].nombre_modalidad,
            carrera: carrera.carrera.nombre_carrera,
            ecommerce: {
              checkout: {
                actionField: {
                  step: 6,
                },
              },
            },
          },
        });
        break;
      default:
        break;
    }
  };

  const lastStepTagManager = (data) => {
    const rutCompleto = numDoc
      .replaceAll(".", "")
      .toLowerCase()
      .replaceAll("-", "")
      .toLowerCase();
    const encodedRut = btoa(rutCompleto);
    const docActual = tipos_documentos.find(
      ({ id_tipo_documento }) => id_tipo_documento === parseInt(tipoDoc)
    );
    const sitLabActual = situaciones_laboral.find(
      ({ id_situacion_laboral }) =>
        id_situacion_laboral === parseInt(situacion_laboral)
    );
    const nivEstActual = niveles_estudio.find(
      ({ id_nivel_estudios }) => id_nivel_estudios === parseInt(nivel_estudios)
    );
    const financiamientoActual = financiamientos.find(
      ({ id_financiamiento_carrera }) =>
        id_financiamiento_carrera === parseInt(financiacion)
    );
    const modalidadActual = carreras.filter(({ carreras }) =>
      carreras.find(({ id_carrera }) => id_carrera === carrera.id_carrera)
    );
    TagManager.dataLayer({
      dataLayer: {
        event: "purchase",
        userid: encodedRut,
        tipo_documento: docActual.tipo_documento,
        nivel_estudios: sitLabActual.situacion_laboral,
        situacion_laboral: nivEstActual.nivel_estudios,
        como_financia: financiamientoActual.financiamiento_carrera,
        modalidad: modalidadActual[0].nombre_modalidad,
        carrera: carrera.carrera.nombre_carrera,
        sede: carrera.carrera_modalidad_sede[0].sede.nombre_sede,
        valor_con_beneficio:
          data.simulacion.informacion_financiera.valor_anual_con_becas,
        ecommerce: {
          transaction_id: data.simulacion.simulacion.id_simulacion,
          affiliation: "simulador-advance",
          value: 0,
          tax: 0,
          shipping: 0,
          currency: "CLP",
          items: [
            {
              item_name: carrera.carrera.nombre_carrera,
              item_id: carrera.id_carrera,
              price:
                data.simulacion.informacion_financiera.valor_anual_con_becas,
              item_brand: "ADVANCE",
              item_category: data.simulacion.simulacion.sede,
              item_category2: modalidadActual[0].nombre_modalidad,
              quantity: 1,
            },
          ],
        },
      },
    });
  };

  const setPageWithTagManager = (pageValue) => {
    tagManagerStepper(page);
    setPage(pageValue);
  };

  const Steps = () => {
    switch (page) {
      case 0:
        return (
          <Home
            handleClick={startSimulacionPage1}
            setShowBackButton={setShowBackButton}
            opening={opening}
            msg={openingMsg}
          />
        );
      case 1:
        return (
          <Step1
            setPage={setPageWithTagManager}
            page={page}
            tipoDoc={tipoDoc}
            setTipoDoc={setTipoDoc}
            tipoDocAlert={tipoDocAlert}
            setTipoDocAlert={setTipoDocAlert}
            numDoc={numDoc}
            setNumDoc={setNumDoc}
            numDocAlert={numDocAlert}
            setNumDocAlert={setNumDocAlert}
            email={email}
            setEmail={setEmail}
            emailAlert={emailAlert}
            setEmailAlert={setEmailAlert}
            captcha={captcha}
            setCaptcha={setCaptcha}
            tipos_documentos={tipos_documentos}
          />
        );

      case 2:
        return (
          <Step2
            setPage={setPageWithTagManager}
            page={page}
            nombre={nombre}
            setNombre={setNombre}
            nombreAlert={nombreAlert}
            setNombreAlert={setNombreAlert}
            apellido={apellido}
            setApellido={setApellido}
            apellidoAlert={apellidoAlert}
            setApellidoAlert={setApellidoAlert}
            telefono={telefono}
            setTelefono={setTelefono}
            telefonoAlert={telefonoAlert}
            setTelefonoAlert={setTelefonoAlert}
            region={region}
            setRegion={setRegion}
            regionAlert={regionAlert}
            setRegionAlert={setRegionAlert}
            termycond={termycond}
            setTyc={setTyc}
            situacion_laboralAlert={situacion_laboralAlert}
            setSituacionLaboralAlert={setSituacionLaboralAlert}
            financiacionAlert={financiacionAlert}
            setFinanciacionAlert={setFinanciacionAlert}
            situacion_laboral={situacion_laboral}
            setSituacionLaboral={setSituacionLaboral}
            financiacion={financiacion}
            setFinanciacion={setFinanciacion}
            setNivelEstudiosAlert={setNivelEstudiosAlert}
            nivel_estudiosAlert={nivel_estudiosAlert}
            nivel_estudios={nivel_estudios}
            setNivelEstudios={setNivelEstudios}
            validation={validation}
            regiones={regiones}
            situaciones_laboral={situaciones_laboral}
            financiamientos={financiamientos}
            niveles_estudio={niveles_estudio}
          />
        );

      case 3:
        return (
          <Step3
            setPage={setPageWithTagManager}
            page={page}
            carrera={carrera}
            setCarrera={setCarrera}
            validation={validation}
            carreras={carreras}
            loading={loading_carreras}
            loader={loader}
          />
        );

      case 4:
        return (
          <Step4
            setPage={setPageWithTagManager}
            sede={sede}
            setSede={setSede}
            validation={validation}
            carrera={carrera}
            setCarreraModalidadSede={setCarreraModalidadSede}
            carrera_modalidad_sede={carrera_modalidad_sede}
          />
        );
      case 6:
        return (
          <Step6
            setPage={setPageWithTagManager}
            certificado={certificado}
            valor_matricula_anual={valor_matricula_anual}
            valor_arancel_anual={valor_arancel_anual}
            valor_beca_matricula_unab={valor_beca_matricula_unab}
            valor_beca_arancel_unab={valor_beca_arancel_unab}
            valor_matricula_anual_unab={valor_matricula_anual_unab}
            valor_anual_con_becas={valor_anual_con_becas}
            valor_mensual_con_becas={valor_mensual_con_becas}
            valor_sede={valor_sede}
            valor_nombre_carrera={valor_nombre_carrera}
            caracteristica_1={caracteristica_1}
            caracteristica_2={caracteristica_2}
            caracteristica_3={caracteristica_3}
            downseling={downseling}
            setNuevaSimulacion={setNuevaSimulacion}
            loadingFinal={loadingFinal}
            setLoadingFinal={setLoadingFinal}
            permitir_envio={permitir_envio}
            jwt={getLocalStorageJWT()}
          />
        );

      default:
        return <Home />;
        break;
    }
  };

  useEffect(() => {
    if (simulacion !== "") {
      setLoader(false);
    }
  }, [simulacion]);

  const setLocalStorageJWT = (jwt) => {
    localStorage.setItem("jwt", jwt);
  };
  const getLocalStorageJWT = () => {
    const jwt = localStorage.getItem("jwt");
    return jwt;
  };

  const simulacionEnd = (obj) => {
    APIS.simulacionEnd(obj, getLocalStorageJWT())
      .then((response) => {
        const simulacion = response.data.data.simulacion;
        const certificado =
          response.data.data.simulacion.simulacion.id_certificado;
        let downseling = response.data.data.downselling;

        setCertificado(certificado);
        setValuesStep6(simulacion);
        setCaracteristica_1(
          response.data.data.simulacion.simulacion.caracteristica_1
        );
        setCaracteristica_2(
          response.data.data.simulacion.simulacion.caracteristica_2
        );
        setCaracteristica_3(
          response.data.data.simulacion.simulacion.caracteristica_3
        );

        downseling = downseling.slice(0, 2);
        setDownseling(downseling);
        setPermitirEnvio(response.data.data.permitir_envio);
        lastStepTagManager(response.data.data);
        setLoadingFinal(false);
      })
      .catch(function (error) {
        console.error(error.response);
        const errorRES = error.response?.data?.error_message;
        alert(errorRES);

        setPage(6);
        setLoadingFinal(false);
      });
  };

  const setValuesStep6 = (simulacion) => {
    setValorMatriculaAnual(
      simulacion.informacion_financiera.valor_matricula_anual
    );
    setValorArancelAnual(simulacion.informacion_financiera.valor_arancel_anual);
    setValorMatriculaUnab(
      simulacion.informacion_financiera.valor_beca_matricula_unab
    );
    if ("valor_beca_arancel_unab" in simulacion.informacion_financiera) {
      setValorArancelUnab(
        simulacion.informacion_financiera.valor_beca_arancel_unab
      );
    }
    setValorAnualConBecas(
      simulacion.informacion_financiera.valor_anual_con_becas
    );
    setValorMensualConBecas(
      simulacion.informacion_financiera.valor_mensual_con_becas
    );
    setValorNombreCarrera(simulacion.simulacion.nombre_carrera);
    setValorSede(simulacion.simulacion.sede);
  };

  const simulacionStart = (obj) => {
    APIS.simulacionStart(obj)
      .then((response) => {
        const simulacion = response.data.data.id_simulacion;
        setSimulacion(simulacion);
        setLoading(false);
        setNuevaSimulacion(false);
      })
      .catch(function (error) {
        console.error(error);
      });
  };

  const estudiantePut = (obj, jwt) => {
    APIS.estudiantePut(obj, jwt)
      .then(function (response) {
        setEstudiante(response.data.data);
        if (nueva_simulacion) {
          Start_simulation();
        }
      })
      .catch(function (error) {
        console.error(error);
      });
  };

  const setInputsStep2 = (estudiante) => {
    setNombre(estudiante.nombre ? estudiante.nombre : "");
    setApellido(estudiante.apellido ? estudiante.apellido : "");
    setTelefono(estudiante.celular ? estudiante.celular.slice(2, 11) : "");
    setNivelEstudios(
      estudiante.id_nivel_estudios ? estudiante.id_nivel_estudios : ""
    );
    setSituacionLaboral(
      estudiante.id_situacion_laboral ? estudiante.id_situacion_laboral : ""
    );
    setFinanciacion(
      estudiante.id_financiamiento_carrera
        ? estudiante.id_financiamiento_carrera
        : ""
    );
  };

  const estudianteGet = () => {
    APIS.estudianteGet(tipoDoc, numDoc.replace(/\./g, "")).then((res) => {
      const estudiante = res.data.data;
      if (estudiante !== null) {
        setInputsStep2(estudiante);
      } else {
        setNombre("");
        setApellido("");
        setTelefono("");
        setNivelEstudios("");
        setSituacionLaboral("");
        setFinanciacion("");
      }
      setEstudiante(res.data.data);
    });
  };

  const getOpeningData = () => {
    APIS.getOpeningData()
      .then((res) => {
        const obj = res.data;
        setOpening(obj.apertura);
        setOpeningMsg(obj.mensaje_cierre);
      })
      .catch(function (error) {
        console.error(error);
      });
  };

  const getCarrerasData = () => {
    setLoadingCarreras(true);
    APIS.getCarreras().then((res) => {
      const carreras = res.data;
      setCarreras(carreras.data);
      setLoadingCarreras(false);
    });
  };

  const Start_simulation = () => {
    const body = {
      email: email,
      id_tipo_documento: tipoDoc,
      numero_documento: numDoc.replace(/\./g, ""),
    };
    APIS.startSimulation(body)
      .then((res) => {
        const estudiante = res.data.estudiante;
        const simulacion = res.data.id_simulacion;
        setLocalStorageJWT(res.data.jwt);
        setSimulacion(simulacion);
        setNuevaSimulacion(false);
        if (estudiante !== null) {
          setInputsStep2(estudiante);
        } else {
          setNombre("");
          setApellido("");
          setTelefono("");
          setNivelEstudios("");
          setSituacionLaboral("");
          setFinanciacion("");
        }
        setEstudiante(estudiante);
        setLoading(false);
      })
      .catch(function (error) {
        console.error(error);
      });
  };

  useEffect(() => {
    if (page === 0) {
      getOpeningData();
      startSimulacionPage0();
      //getCarrerasData()
    }
    if (page === 2) {
      //estudianteGet()
      Start_simulation();
    }
    if (page === 3) {
      //setLoading(true)
      const postobject = {
        id_estudiante: estudiante.id_estudiante,
        nombre: nombre,
        apellido: apellido,
        email: email,
        celular: 56 + telefono,
        id_tipo_documento: parseInt(tipoDoc),
        numero_documento: numDoc.replace(/\./g, ""),
        id_nivel_estudios: parseInt(nivel_estudios),
        id_situacion_laboral: parseInt(situacion_laboral),
        id_financiamiento_carrera: parseInt(financiacion),
      };
      estudiantePut(postobject, getLocalStorageJWT());
    }
    if (page === 6) {
      let obj = {
        id_carrera_modalidad_sede: carrera_modalidad_sede,
        id_estudiante: estudiante.id_estudiante,
        id_simulacion: simulacion,
      };
      simulacionEnd(obj);
    } else {
      setLoading(false);
    }
  }, [page]);

  useEffect(() => {
    if (nivel_estudios !== "") {
      setLoadingCarreras(true);
      APIS.getCarreras().then((res) => {
        const carreras = res.data;
        setCarreras(carreras.data);
        setLoadingCarreras(false);
      });
    }
  }, [nivel_estudios]);

  useEffect(() => {
    APIS.getTiposDoc().then((res) => {
      setTiposDocumentos(res.data.data);
    });
    APIS.getSituacionLaboral().then((res) => {
      setSituacionesLaboral(res.data.data);
    });
    APIS.getNivelesEstudio().then((res) => {
      setNivelesEstudio(res.data.data);
    });
    APIS.getFinanciamiento().then((res) => {
      setFinanciamientos(res.data.data);
    });
  }, []);

  const validation = (actualPage) => {
    switch (actualPage) {
      case 1:
        return validationPage1();
        break;
      case 2:
        return validationPage2();
        break;
      case 3:
        return validationPage3();
        break;
      case 4:
        return validationPage4();
        break;

      default:
        break;
    }
    return true;
  };

  const validarMail = (mail) => {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
      return true;
    } else {
      //setEmailAlert(true)
      return false;
    }
  };

  const validacionesRut = {
    // Valida el rut con su cadena completa "XXXXXXXX-X"
    validaRut: function (rutCompleto) {
      if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test(rutCompleto)) return false;
      var tmp = rutCompleto.split("-");
      var digv = tmp[1];
      var rut = tmp[0];
      if (digv == "K") digv = "k";
      return validacionesRut.dv(rut) == digv;
    },
    dv: function (T) {
      var M = 0,
        S = 1;
      for (; T; T = Math.floor(T / 10))
        S = (S + (T % 10) * (9 - (M++ % 6))) % 11;
      return S ? S - 1 : "k";
    },
  };

  const validarRut = (value) => {
    if (validacionesRut.validaRut(value)) {
      return true;
    } else {
      return false;
    }
  };

  const validationPage2 = () => {
    let isOk = true;

    if (nombre === "") {
      isOk = false;
      //setNombreAlert("error_label")
    }

    if (apellido === "") {
      isOk = false;
      //setApellidoAlert("error_label")
    }

    if (telefono === "" || telefono.length !== 10) {
      isOk = false;
      //setTelefonoAlert("error_label")
    }

    if (financiacion === "") {
      isOk = false;
    }

    if (situacion_laboral === "") {
      isOk = false;
    }

    if (nivel_estudios === "") {
      isOk = false;
    }

    if (termycond !== true) {
      isOk = false;
    }

    return isOk;
  };

  const validationPage1 = () => {
    let isOk = true;
    if (tipoDoc === "") {
      isOk = false;
      //setTipoDocAlert("error_label")
    }

    if (!validarMail(email)) {
      isOk = false;
      //setEmailAlert("error_label")
    }

    if (!validarRut(numDoc)) {
      isOk = false;
      //setNumDocAlert("error_label")
    }

    if (captcha === false) {
      isOk = false;
    }
    return isOk;
  };

  const validationPage3 = () => {
    let isOk = true;

    if (carrera === "") {
      isOk = false;
    }

    return isOk;
  };

  const validationPage4 = () => {
    let isOk = true;

    if (sede === "") {
      isOk = false;
    }

    return isOk;
  };

  return (
    <div className="App">
      {loading ? (
        <>
          <Loader />
        </>
      ) : (
        <>
          {
            /*CAMBIAR EL 7 POR UN NUMB Q TENGA SENTIDO */ page === 7 ? null : (
              <>
                <Header page={page} setPage={setPage} />{" "}
              </>
            )
          }
          {Steps()}
          {page === 0 || page === 6 ? null : (
            <>
              {" "}
              <Footer
                validation={validation}
                setPage={setPage}
                page={page}
                tagManagerStepper={tagManagerStepper}
              />
            </>
          )}
        </>
      )}
    </div>
  );
}

export default App;
